/**
 * This file contains legacy utilities from the old implementation (Modular Framework)
 * and its use is not recommended or enhancement, as it may run the risk
 * of being suddenly decommissioned.
 *
 * Bonus points if you manage to remove these dependecies from the code! Good luck
 */

const SET_DOCUMENT_TITLE = 'SET_DOCUMENT_TITLE';
// eslint-disable-next-line camelcase
export const LEGACY_sendMessage = (message) => {
  const { type, payload } = message;
  const notAllowedMessage = !type || type !== SET_DOCUMENT_TITLE || !payload;
  if (notAllowedMessage) {
    throw Error(`Unknown message type: ${type}`);
  }

  const { body: { title } } = payload;
  if (title) {
    window.document.title = title;
  }
};
